import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconPetCollarProps } from './IconPetCollar.types'
import * as Styled from './styles/IconPetCollar.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPetCollar: FC<IconPetCollarProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPetCollarProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconPetCollarProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M10.508 12.156C5.968 11.91 2.5 10.57 2.5 8.95' vectorEffect='non-scaling-stroke' />
          <path
            d='M2.5 9.063c0-1.793 4.25-3.25 9.5-3.25s9.5 1.453 9.5 3.25v-.114c0 1.403-2.602 2.598-6.242 3.051M11 15.656c-4.777-.172-8.5-1.55-8.5-3.23m19 .114v-.114c0 1.398-2.582 2.59-6.203 3.047'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M4.125 10.727C5.832 9.859 8.723 9.293 12 9.293c3.07 0 6.02.66 7.758 1.434M2.5 8.953v3.559m19-3.426v3.426m-6.395-.492c.02.085.028.175.028.261v3.043c0 .692-.559 1.25-1.25 1.25h-2.125a1.25 1.25 0 0 1-1.25-1.25v-3.043c0-.691.562-1.25 1.25-1.25h2.125c.59 0 1.101.414 1.222.989M8.55 13.613a.1.1 0 0 1-.097.102.1.1 0 0 1-.098-.102c0-.054.043-.097.098-.097.055 0 .098.043.098.097ZM6 13.207a.097.097 0 0 1-.098.098.1.1 0 0 1-.101-.098.1.1 0 0 1 .101-.098c.055 0 .098.043.098.098Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconPetCollar
